import { setItem, getItem } from '@Utils/LocalStorage';
import { EDITOR_REDUCER_NAME } from '../Editor/Constants';
import { EDITOR_LIST_LOCAL_STORAGE_KEY } from './Constants';

const IGNORE_ACTION_TYPE = `${EDITOR_REDUCER_NAME}/setSelectedProcessId`;

export const saveEditorListInLocalStorage = store => next => action => {
  const { type } = action;
  const result = next(action);

  if (type.startsWith(EDITOR_REDUCER_NAME) && type !== IGNORE_ACTION_TYPE) {
    const editorList = getItem(EDITOR_LIST_LOCAL_STORAGE_KEY, {});
    const targetItem = { ...editorList };

    const editorKey = store.getState()[EDITOR_REDUCER_NAME].projectId;
    targetItem[editorKey] = store.getState()[EDITOR_REDUCER_NAME];

    if (editorKey) {
      setItem(EDITOR_LIST_LOCAL_STORAGE_KEY, targetItem);
    }
  }

  return result;
};
